import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { useAuth } from '@/context/AuthContext';
import {
  UserIcon,
  EnvelopeIcon,
  ClipboardDocumentListIcon,
  ArrowRightOnRectangleIcon,
} from '@heroicons/react/24/outline';

export const Profil = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <>
      <Navbar />
      <main className="client-page">
        <div className="client-page-container">
          <h1 className="gtitle client-page-title">
            <span className="gtitle-light">{t('clientPages.profile.titleLight')}</span>{' '}
            <span className="gtitle-strong">{t('clientPages.profile.titleStrong')}</span>
          </h1>

          <section className="client-profile-card" aria-label={t('clientPages.profile.accountInfo')}>
            <div className="client-profile-avatar" aria-hidden="true">
              <UserIcon />
            </div>
            <div className="client-profile-details">
              <h2>{user.fullName}</h2>
              <p className="client-profile-row">
                <EnvelopeIcon className="client-profile-row-icon" aria-hidden="true" />
                {user.email}
              </p>
            </div>
          </section>

          <nav className="client-profile-links" aria-label={t('clientPages.profile.quickLinks')}>
            <Link to="/mes-commandes" className="client-profile-link">
              <ClipboardDocumentListIcon className="client-profile-link-icon" aria-hidden="true" />
              <span>{t('clientPages.profile.myOrders')}</span>
            </Link>
            <Link to="/order-tracking" className="client-profile-link">
              <ClipboardDocumentListIcon className="client-profile-link-icon" aria-hidden="true" />
              <span>{t('clientPages.profile.trackOrder')}</span>
            </Link>
            <Link to="/boutique" className="client-profile-link">
              <span>{t('clientPages.profile.continueShopping')}</span>
            </Link>
          </nav>

          <button type="button" className="client-profile-logout" onClick={() => logout()}>
            <ArrowRightOnRectangleIcon className="client-profile-link-icon" aria-hidden="true" />
            {t('clientPages.profile.logout')}
          </button>
        </div>
      </main>
      <Footer />
    </>
  );
};
